export default function PHP_metaphone() {
  return (
    <div>
      <h1>PHP_metaphone</h1>
    </div>
  );
}
